import React, { createContext, useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";

import classes from "./Layout.module.scss";
import { UserInfoInterface, useGetCurrentUser } from "hooks/queries/user-auth/useGetCurrentUser";
import {TranslationWrapper} from "../../services/i18n/settings";

export type Props = { children?: React.ReactNode };

export const UserContext = createContext<{ user?: UserInfoInterface }>({ user: {} });

const Layout = ({ children }: Props) => {
	const currentUser = useGetCurrentUser({}, { retry: false });

	useEffect(() => {
		window.addEventListener("storage", () => {
			currentUser.refetch();
		});
	}, []);

	return (
		<UserContext.Provider value={{ user: currentUser.data?.data }}>
            <TranslationWrapper>
                <div className={classes.wrapper}>
                    <Header />
                    <div className={classes.content}>{children}</div>
                    <Footer />
                </div>
            </TranslationWrapper>
		</UserContext.Provider>
	);
};

export default Layout;
